import { html } from '../../../../../lit-html/lit-html.js';

/*
src/@littleware/little-elements/modules/authMgr/
*/
export const css = html`
<style id="lw-authMgr-css">
lw-auth-ui {
  width: 100px;
  display: block;
}

</style>
`;
